import {CreateTreeNode} from "../view-model";

export const collectAllCaIds = <T extends CreateTreeNode<T>>(
  node: T
): string[] => {
  const accumulator: string[] = [];
  accumulator.push(node.caId);
  for (const child of node.children) {
    accumulator.push(...collectAllCaIds(child));
  }
  return accumulator;
};
